import Splide from '@splidejs/splide';

(() => {
  const query = document.querySelector('.accreditations .splide');
  if (!query) return;

  const splide = new Splide('.accreditations .splide', {
    type: 'slider',
    perPage: 6,
    perMove: 1,
    gap: '2rem',
    pagination: false,
    arrows: false,
    breakpoints: {
      1200: {
        perPage: 5,
        pagination: true,
      },
      992: {
        perPage: 4,
      },
      768: {
        perPage: 3,
      },
      576: {
        perPage: 2,
      },
      400: {
        perPage: 1,
      },
    },
  });

  splide.mount();
})();
